import type { editor as it } from "../it/editor.ts";

/** Editor del compose e dell'environment. */
export const editor: typeof it = {
  "editor.cerca": "Search text",
  "editor.sostituisciCon": "Replace with",
  "editor.successiva": "next",
  "editor.precedente": "previous",
  "editor.tutte": "all",
  "editor.maiuscole": "match case",
  "editor.regex": "regex",
  "editor.parolaIntera": "by word",
  "editor.sostituisci": "replace",
  "editor.sostituisciTutte": "replace all",
  "editor.chiudi": "close",
  "editor.righeRipiegate": "Folded lines",
  "editor.righeAperte": "Unfolded lines",
  "editor.ripiega": "Fold line",
  "editor.apri": "Unfold line",
  "editor.copiaTutto": "Copy all to clipboard",
  "editor.cercaScorciatoia": "Search text (Ctrl+F)",
  "editor.schermoIntero": "Open full screen",
  "editor.titolo": "Editor",
  "editor.aiutoSchermoIntero": (p: { righe: number }) => `${p.righe} lines · Ctrl+F search · Esc exit`,

  "env.testoAiuto": "One variable per line, as KEY=value. Handy for pasting a whole block.",
  "env.nessunaMancante": "No missing variables: the compose has everything it needs.",
  "env.mancantiAiuto":
    "Variables the compose requires that nobody has set yet: without a value, the deploy would stop here.",
  "env.filtroSegnaposto": "Filter by name or value",
  "env.filtro": "Filter variables",
  "env.filtrate": (p: { n: number; totale: number }) => `${p.n} of ${p.totale}`,
  "env.aggiungineUna": "Add one with the button below.",
  "env.nessunaCorrisponde": (p: { filtro: string }) => `No variables match "${p.filtro}".`,
  "env.assegnataAvvio": "assigned on deploy",
  "env.gestita": "managed by Portman",
  "env.aggiungi": "Add variable",
  "env.mancanti": "Missing",
  "env.testo": "Text",
  "env.statoInutilizzata": "defined but not used by the compose",
  "env.statoRichiesta": "required by the compose",
  "env.chiave": "KEY",
  "env.nelCompose": "in compose",
  "env.nonUsata": "unused",
  "env.nascosto": "hidden",
  "env.rimuovi": (p: { nome: string }) => `Remove ${p.nome}`,
  "env.variabile": "variable",
};
